import React from 'react';
import moment from 'moment';

import { DatePickerField } from 'src/components/DatePickerField/DatePickerField';
import { QuestionMonthDefaultProps, QuestionMonthPropTypes } from 'src/components/JobDatasheet/propTypes';

export const QuestionMonth = ({
  errors,
  flash,
  isRectifiedQuestion,
  onChange,
  value,
  disableChange,
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';

  const getReturnObject = (val => {
    const returnObject = {
      ...value,
      type: 'month'
    };

    returnObject[selectedValueKey] = val ? moment(val).format('YYYY-MM-DD') : null;

    return returnObject;
  });

  return (
    <DatePickerField
      dateOnly
      error={(errors || []).join(' & ')}
      flash={flash}
      fullsize
      monthOnly
      onChange={!disableChange && ((v) => onChange(getReturnObject(v)))}
      value={value ? value[selectedValueKey] : ''}
      popperPlacement={'bottom-start'}
    />
  );
};

QuestionMonth.propTypes = QuestionMonthPropTypes;
QuestionMonth.defaultProps = QuestionMonthDefaultProps;
